// src/App.js

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { setOnForbidden } from './api'; // ← your API file
import './App.css';
import { ToastContainer } from 'react-toastify';

function AppContent() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Hook up the 403 handler
    setOnForbidden(() => {
      setShowModal(true);
    });
  }, []);

  const handleRedirect = () => {
    localStorage.removeItem('authData');
    setShowModal(false);
    navigate('/Home');
  };

  return (
    <>
      <AppRoutes />

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Session Expired</h3>
            <p>Your session or token has expired. Please log in again to continue.</p>
            <button onClick={handleRedirect}>Go to Login</button>
          </div>
        </div>
      )}
      <ToastContainer 
        position="top-right" 
        autoClose={2000} 
        theme="colored"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
